import React from "react";

const ArrowRight = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.157" height="26.561" viewBox="0 0 14.157 26.561">
        <path
            id="arrow_right"
            data-name="arrow right"
            d="M5252.124-164.889l10-11.668-10-12.332"
            transform="translate(-5250.57 190.149)"
            fill="none"
            stroke="#aaa081"
            stroke-width="4"/>
    </svg>

);

export default ArrowRight;
